import React from 'react'
import { useTranslation } from 'react-i18next'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'

import InfoBlock from '../components/InfoBlock'
import { InvestorNameCell } from '../../components/entities/InvestorNameCell'
import { formatMoney, formatPercentage } from '../../packages/utils/numberFormatters'

const compareBySizeAndName = (a, b) => {
    const aSize = a.amountInCash
    const bSize = b.amountInCash
    if (aSize > bSize) {
        return -1
    }
    if (aSize < bSize) {
        return 1
    }
    if (a.name < b.name) {
        return -1
    }
    if (a.name > b.name) {
        return 1
    }
    return 0
}

function Investors({ issue }) {
    const { t, i18n } = useTranslation()
    const locale = i18n.language

    const investors = issue.investors.filter((investor) => !investor.isSeller)
    let content = null

    if (!issue.noInvestorsNamedChecked && investors.length > 0) {
        const totalInvestorsSize = investors.reduce((acc, row) => acc + row.amountInCash, 0) || null
        const totalInvestorsPercentage = investors.reduce((acc, row) => acc + row.amountInPercentage, 0) || null
        content = (
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('site.table.name')}</TableCell>
                            <TableCell>{t('pages.issues.investors.amountWithCurrency', { currency: issue.currency })}</TableCell>
                            <TableCell>{t('pages.issues.investors.share')}</TableCell>
                            <TableCell>{t('pages.issues.investors.leo')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {investors
                            .filter((investor) => !investor.isSeller)
                            .sort(compareBySizeAndName)
                            .map((investor) => {
                                return (
                                    <TableRow
                                        key={investor.id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell>
                                            <InvestorNameCell
                                                name={investor.name}
                                                investorId={investor.investorId}
                                                putOption={investor.putOption}
                                            />
                                        </TableCell>
                                        <TableCell component='td' scope='row'>
                                            {formatMoney(investor.amountInCash, {
                                                locale,
                                                decimals: 0,
                                            })}
                                        </TableCell>
                                        <TableCell component='td' scope='row'>
                                            {formatPercentage(investor.amountInPercentage, {
                                                locale,
                                                decimals: 0,
                                            })}
                                        </TableCell>
                                        <TableCell>{investor.leo ? t('pages.issues.investors.yes') : ''}</TableCell>
                                    </TableRow>
                                )
                            })}
                        <TableRow>
                            <TableCell>
                                <b>{t('site.table.total')}</b>
                            </TableCell>
                            <TableCell>
                                <b>{formatMoney(totalInvestorsSize, { locale, decimals: 0 })}</b>
                            </TableCell>
                            <TableCell>
                                <b>
                                    {formatPercentage(totalInvestorsPercentage, {
                                        locale,
                                        decimals: 0,
                                    })}
                                </b>
                            </TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                        {totalInvestorsPercentage < 99 && (
                            <TableRow>
                                <TableCell colSpan={4}>
                                    <i>{t('pages.issues.investors.incompleteInfo')}</i>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        )
    } else {
        content = (
            <span>
                <i>{t('pages.issues.investors.incompleteInfo')}</i>
            </span>
        )
    }

    return (
        <InfoBlock title={t('entities.investor.plural')} loadingElement={!content}>
            {content}
        </InfoBlock>
    )
}

export default Investors
